<template>
  <v-dialog
    persistent
    v-model="subscriptionCentreModal"
    content-class="subscription-modal-box input-container"
  >
    <v-card>
      <!-- <loader v-if="showLoader"></loader> -->
      <v-card-title class="headline grey lighten-2 pl-5">
        Number of Centres
        <div class="spacer"></div>
        <CButtonClose @click.stop="$emit('close')" />
      </v-card-title>
      <v-card-text>
        <CRow>
          <CCol sm="12" md="12" class="pb-0">
            <h4 class="history-title mb-2">{{ centersInfo.user.full_name }}</h4>
            <!-- <h4 class="history-title mb-2">Centre Name</h4> -->
          </CCol>
        </CRow>
        <CRow>
          <div class="search-div subsearch col-sm-6 col-md-4">
            <label for>Search by Username</label>
            <input
              v-model="usernameSearch"
              @input="debounceSearch(usernameSearch)"
              @click="getStatus('username')"
              class="form-control"
              label="Search"
              placeholder="Search"
            />
            <div class="search-svg">
              <searchSVG />
            </div>
          </div>
          <div class="search-div subsearch col-sm-6 col-md-4">
            <label for>Search by Location</label>
            <input
              v-model="locationSearch"
              @click="getStatus('location')"
              @input="debounceSearch(locationSearch)"
              class="form-control"
              label="Search"
              placeholder="Search"
            />
            <div class="search-svg">
              <searchSVG />
            </div>
          </div>
          <div class="col-md-3 col-sm-6">
            <label class="col-sm-12 mb-0 d-none-mob1" for></label>
            <v-btn
              :loading="csvLoader"
              @click="downloadCsv()"
              class="btn btn-primary mt-0"
              >Export</v-btn
            >
          </div>
        </CRow>

        <CRow>
          <CCol sm="12" class="pl-0 pr-0">
            <div class="overflow-auto">
              <!-- changes done by durgesh on 21-1-2022 -->
              <table class="table userlistTable subscriptable">
                <thead>
                  <tr class="table-success">
                    <!-- 1 -->
                    <th scope="col" class="min-width-50">Sr No.</th>
                    <!-- 2-->
                    <th scope="col" class="min-width-120">Centre Name</th>
                    <!-- 3 -->
                    <th scope="col" class="min-width-120">Contact Number</th>
                    <!--  4-->
                    <th scope="col" class="min-width-120">Location</th>
                    <!-- 5-->
                    <th scope="col" class="min-width-120">Date of Purchase</th>
                    <!--  6-->
                    <th scope="col" class="min-width-130">Expiry Date</th>
                    <!--  7-->
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-show="!showLoader"
                    v-for="(item, i) in centerDetails"
                    :key="i"
                  >
                    <!-- 1. Sr No. -->
                    <td>{{ i + 1 }}</td>
                    <!-- 2. Centre Name -->
                    <td>{{ item.general.name }}</td>
                    <!-- 3. Contact Number -->
                    <td>{{ item.general.contact_number }}</td>
                    <!-- 4. Location -->
                    <td>
                      {{
                        item.general &&
                        item.general.address &&
                        item.general.address.city
                          ? item.general.address.city
                          : "&#8213;"
                      }}
                    </td>
                    <!-- 5. Date of Purchase -->
                    <td>
                      {{
                        centersInfo.date_of_purchase
                          ? dayJS(centersInfo.date_of_purchase).format(
                              formats.date_format
                            )
                          : "&#8213;"
                      }}
                    </td>
                    <!-- 6. Expiry Date -->
                    <td>
                      {{
                        centersInfo.expiration_date
                          ? dayJS(centersInfo.expiration_date).format(
                              formats.date_format
                            )
                          : "&#8213;"
                      }}
                    </td>
                    <!-- 7. Action -->
                    <td class="action-div small-table-padding border-bottom">
                      <!-- <div> -->
                      <CDropdown
                        color="link"
                        size="lg"
                        :caret="false"
                        class="dropdowndocbox"
                      >
                        <template #toggler-content>
                          <verticalDotsSVG />
                        </template>
                        <CDropdownItem @click="goToHistory(item)"
                          >History</CDropdownItem
                        >
                      </CDropdown>
                      <!-- </div> -->
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <v-skeleton-loader
                        v-if="showLoader"
                        v-bind="attrs"
                        type="list-item-avatar, divider,list-item-avatar, divider,list-item-avatar"
                      ></v-skeleton-loader>
                    </td>
                  </tr>

                  <tr v-if="!showLoader">
                    <td colspan="6">
                      <div v-if="centerDetails.length <= 0">
                        <h2 class="text-center">No Data Found</h2>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCol>

          <!-- this filter for active user page end -->
        </CRow>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import formats from "@/formats";
import debounce from "lodash/debounce";
export default {
  props: ["subscriptionCentreModal", "centersInfo", "role"],
  data() {
    return {
      dayJS,
      formats,
      usernameSearch: "",
      locationSearch: "",
      centerDetails: [],
      newData: [],
      isEmpty: false,
      showLoader: false,
      status: "",
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      csvLoader: false,
      userId: "",
    };
  },
  components: {
    ...pickSvg("verticalDotsSVG", "nonverifiedUserSVG", "verifiedUserSVG"),
    Datepicker,
  },
  mounted() {
    this.centerDetails = this.centersInfo.center;
    this.userId = this.centersInfo._id;
  },
  methods: {
    downloadCsv() {
      this.csvLoader = true;
      let params = {
        subscription_id: this.userId,
        location: this.locationSearch,
        center_name: this.usernameSearch,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscription/center-listing/csv`;

      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.csvLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },

    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },

    getStatus(name) {
      this.status = name;
    },
    debounceSearch: debounce(function (search) {
      this.showLoader = true;
      setTimeout(() => {
        if (this.status === "username") {
          this.centerDetails = this.centersInfo.center.filter((center) =>
            center.general.name.toLowerCase().includes(search.toLowerCase())
          );
        } else {
          this.centerDetails = this.centersInfo.center.filter((center) =>
            center.general.address.city
              .toLowerCase()
              .includes(search.toLowerCase())
          );
        }

        this.showLoader = false;
      }, 1000);
    }, 500),

    goToHistory(data) {
      this.sendData = {
        role: this.role,
      };
      if (this.role === "doctor") {
        this.sendData.user_id = data.user._id;
      } else {
        this.sendData.user_id = data.created_by;
        this.sendData.center_id = data._id;
      }

      this.$router.push({
        name: "Subscription History",
        query: { ...this.sendData },
      });
    },
  },
};
</script>